import { animate, stagger } from "./anime.esm.min.js";

import videojs from "video.js";
import Player from "video.js/dist/types/player";
import "videojs-youtube";


import * as THREE from './three.module.min.js';
import {GLTFLoader} from './GLTFLoader.min.js';
import { DRACOLoader } from './DRACOLoader.min.js';

import { GeoJSONSource, Map } from 'maplibre-gl';




var video_player: Player;
var map: MapManager;
var scene_3d: scene3D;
const video_width = 1920; //player.currentWidth();
const video_height = 1440; //player.currentHeight();

function dimension(el) {
    let elmHeight;
    let elmMargin;

    elmHeight = el.getBoundingClientRect().height;
    elmMargin = parseFloat(document.defaultView.getComputedStyle(el, '').getPropertyValue('margin-top')) + parseFloat(document.defaultView.getComputedStyle(el, '').getPropertyValue('margin-bottom'));
    
    return (elmHeight+elmMargin);
}


const MAX_WIDTH_PX = 1400;
function css_ratio_from(px){
    return Math.min(px, px / MAX_WIDTH_PX * window.innerWidth);
}
function css_full_ratio_from(px){
    let vw = px / MAX_WIDTH_PX * 100;
    return `min(${px}px, ${vw}vw)`;
}

// Converts from degrees to radians.
function toRadians(degrees) {
    return degrees * Math.PI / 180;
  };
   
  // Converts from radians to degrees.
  function toDegrees(radians) {
    return radians * 180 / Math.PI;
  }
  
function distance(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = toRadians(lat2 - lat1);  // deg2rad below
    var dLon = toRadians(lon2 - lon1); 
    var a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2)
      ; 
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    var d = R * c; // Distance in km
    return d;
  }


let mapjson = require("url:../assets/map_data.json");
let example_GPX = require("../assets/adultes/exemple.gpx");

let green_GPX = require("../assets/GPX/Vert.gpx");
let blue_GPX = require("../assets/GPX/Bleu.gpx");
let red_GPX = require("../assets/GPX/Rouge.gpx");
let black_GPX =  require("../assets/GPX/Noir.gpx");
let sharktooth_GPX = require("../assets/GPX/Dent.gpx");
let fourcross_GPX = require("../assets/GPX/Four.gpx");
let bernard_GPX = require("../assets/GPX/Piste.gpx");
let remontee_GPX = require("../assets/GPX/Remontee.gpx");

let green_url = "https://www.youtube.com/watch?v=JAGvRcyrb80";
let blue_url = "https://www.youtube.com/watch?v=2byvAjiwiSM";
let red_url = "https://www.youtube.com/watch?v=FWL9A0TYLxQ";
let black_url = "https://www.youtube.com/watch?v=DtaHLxa4t5I";
let sharktooth_url = "https://www.youtube.com/watch?v=wzm5QHfAfK0";
let fourcross_url = "https://www.youtube.com/watch?v=vhytQRiw9co";
let bernard_url = "https://www.youtube.com/watch?v=VxhPMqSt4Qs";
let remontee_url = "https://youtu.be/b2ZxgZV-L2s";

let green_timestamp = new Date("2025-11-22T13:19:38.000Z").getTime() / 1000;
let blue_timestamp = new Date("2025-11-22T13:43:12.000Z").getTime() / 1000;
let red_timestamp = new Date("2025-11-22T14:19:39.000Z").getTime() / 1000;
let black_timestamp = new Date("2025-12-09T14:22:19.000Z").getTime() / 1000;;
let sharktooth_timestamp = new Date("2025-12-09T13:06:48.000Z").getTime() / 1000;;
let fourcross_timestamp = new Date("2025-12-09T12:28:57.000Z").getTime() / 1000;;
let bernard_timestamp = new Date("2025-11-22T14:02:31.000Z").getTime() / 1000;
let remontee_timestamp = new Date("2025-11-22T14:09:06.000Z").getTime() / 1000;

let map_tracks = {
    "green": {
        gpx: green_GPX,
        url: green_url,
        timestamp: green_timestamp,
        color: "rgb(39, 174, 96)",
        view: {
            center: [6.76060, 47.59474], 
            zoom: 16.02, 
            zoom_follow: 17.5,
            bearing: -82.99
        }, view_responsive_vertical: {
            center: [6.7608972513043, 47.594939113959526],
            zoom: 15.927023947591296,
            bearing: -32.85309525287504
        }
    },
    "blue": {
        gpx: blue_GPX,
        url: blue_url,
        timestamp: blue_timestamp,
        color: "rgb(52, 152, 219)",
        view: {
            center: [6.75249, 47.59140], 
            zoom: 14.7, 
            zoom_follow: 17.5,
            bearing: 31.93
        }, 
        view_responsive_vertical: {
            center: [6.752228803243042, 47.59135310352096],
            zoom: 14.780748863710318,
            bearing: -25.662482714581074
        }
    },
    "red": {
        gpx: red_GPX,
        url: red_url,
        timestamp: red_timestamp,
        color: "rgb(231, 76, 60)",
        view: {
            center: [6.75249, 47.59140], 
            zoom: 14.7, 
            zoom_follow: 17.5,
            bearing: 31.93
        },
        view_responsive_vertical: {
            center: [6.752228803243042, 47.59135310352096],
            zoom: 14.780748863710318,
            bearing: -25.662482714581074
        }
    },
    "black": {
        gpx: black_GPX,
        url: black_url,
        timestamp: black_timestamp,
        color: "rgb(44, 62, 80)",
        view: {
            center: [6.75249, 47.59140], 
            zoom: 14.7, 
            zoom_follow: 17.5,
            bearing: 31.93
        },
        view_responsive_vertical: {
            center: [6.752228803243042, 47.59135310352096],
            zoom: 14.780748863710318,
            bearing: -25.662482714581074
        }
    },
    "sharktooth": {
        gpx: sharktooth_GPX,
        url: sharktooth_url,
        timestamp: sharktooth_timestamp,
        color: "rgba(202, 72, 57, 1)",
        view: {
            center: [6.75392, 47.59093],
            zoom: 16.6,
            zoom_follow: 17.5,
            bearing: -20
        }, view_responsive_vertical: {
            center: [6.75392, 47.59082],
            zoom: 16.73,
            bearing: -15
        }
    },
    "fourcross": {
        gpx: fourcross_GPX,
        url: fourcross_url,
        timestamp: fourcross_timestamp,
        color: "rgb(155, 89, 182)",
        view: { 
            center: [6.75490, 47.59202],
            zoom: 16.9,
            zoom_follow: 17.5,
            bearing: -20
        }, view_responsive_vertical: { // bh {lng: 6.75476080069086, lat: 47.59209739080137} 16.952075512425996 -71.35631878712394
            center: [6.75476, 47.59210],
            zoom: 16.95,
            bearing: -71.35
        }
    },
    "bernard": {
        gpx: bernard_GPX,
        url: bernard_url,
        timestamp: bernard_timestamp,
        color: "rgb(230, 126, 34)",
        view: {
            center: [6.75558, 47.59099], 
            zoom: 19.45, 
            zoom_follow: 19.45,
            bearing: 9.46
        }, view_responsive_vertical: { // bh {lng: 6.755572638171998, lat: 47.59099663168183} 19.43678554063465 -31.720113335264735
            center: [6.75557, 47.59100],
            zoom: 19.43,
            bearing: -31.72
        }
    },
    "remontee": { 
        gpx: remontee_GPX,
        url: remontee_url,
        timestamp: remontee_timestamp,
        color: "rgb(241, 196, 15)",
        view: {
            center: [6.75463, 47.59165], 
            zoom: 16.4, 
            zoom_follow: 17,
            bearing: 0.00
        }, view_responsive_vertical: { // bh {lng: 6.754308678672146, lat: 47.59162164434238} 16.319323558728573 -50.02051844601368
            center: [6.75431, 47.59162],
            zoom: 16.32,
            bearing: -59.02
        }

    }
};


document.addEventListener("DOMContentLoaded", () => {
    let video_el = document.getElementById("header-vid");
    video_player = videojs(video_el, {"controls": false, "autoplay": "muted", "preload": "auto", "loop": true});
    resize_video(video_player);

    video_player.ready(() => {// on video time update
        video_player.on('timeupdate', () => {
            if (video_player.currentTime() > 5) video_el.style.opacity = "1";
        });

        setTimeout(() => {
            video_player.currentTime(5);
            video_player.play();
        }, 100);
        let interval = setInterval(() => {
            
            if (video_player.currentTime() > 5) {
                clearTimeout(interval);
                return;
            }
            video_player.currentTime(5);
            video_player.play();
        }, 1000);
    });

    let anime = document.getElementById("H2R-anime")
    setTimeout(() => {    
        anime.style.display = "flex";

        animate("#H2R-anime>img", {
            scale: [100, 1],
            x: {from: stagger("200%", {grid: [3, 1], from: 'center', axis: 'x'}) , to: '0%'},
            delay: stagger(300),
            ease: 'in(1.81)'
        });

        create3Dscene();
    }, 200);

    map = new MapManager();
    map.init("map", [6.75586, 47.59157], 14.4, true);

    let mapex = new MapManager();
    mapex.init("map-example", [6.78586, 47.56697], 12.1);

    let carousels = document.getElementsByClassName("gallery-container");
    for (let i = 0; i < carousels.length; i++) {
        let carousel = carousels[i] as HTMLElement;
        let left_btn = carousel.getElementsByClassName("left")[0] as HTMLElement;
        let right_btn = carousel.getElementsByClassName("right")[0] as HTMLElement;
        let gallery = carousel.getElementsByClassName("gallery")[0] as HTMLElement;
        let els = gallery.getElementsByClassName("image")        
        let el_i = 0;
        let video_js_players: Player[] = [];

        for (let j = 0; j < els.length; j++) {
            // if tag name is video-js create videojs player
            if (els[j].tagName.toLowerCase() == "video-js") {
                let vid_player = videojs(els[j] as HTMLElement, {"controls": false, "autoplay": false, "preload": "auto"});
                video_js_players.push(vid_player);
            }
            else{
                video_js_players.push(null);
            }
            (els[j] as HTMLElement).style.opacity = (j==0) ? "1" : "0";
        }


        left_btn.addEventListener("click", (e) => {
            let next_i = el_i - 1;            
            if (next_i < 0) next_i = els.length - 1;

            let last = els[el_i] as HTMLElement;
            let next = els[next_i] as HTMLElement;
            last.style.opacity = "0";
            next.style.opacity = "1";
            el_i = next_i;
            if (video_js_players[el_i]){
                video_js_players[el_i].currentTime(0);
                video_js_players[el_i].play();
            }
        });

        right_btn.addEventListener("click", (e) => {
            let next_i = el_i + 1;
            if (next_i >= els.length) next_i = 0;

            let last = els[el_i] as HTMLElement;
            let next = els[next_i] as HTMLElement;
            last.style.opacity = "0";
            next.style.opacity = "1";
            el_i = next_i;
            if (video_js_players[el_i]){
                video_js_players[el_i].currentTime(0);
                video_js_players[el_i].play();
            }
        });
    }    
    resize_maps();
});

window.addEventListener("resize", (e) => {
    resize_video(video_player);
    resize_maps();
    scene_3d.resize(window.innerWidth, window.innerHeight);
});

window.addEventListener("scroll", (e) => {
    scene_3d.update_scroll(e);
    update_header();
});


const scroll_sections = [1.7, 2.82, 3.2, 3.5, 10];
function update_header(){
    scene_3d.compute_scroll_px(1)
    // let header = document.getElementById("header-nav") as HTMLElement;
    
    // let ti = 0;
    // while (scene_3d.compute_scroll_px(scroll_sections[ti]) < window.scrollY && ti < scroll_sections.length - 1){
    //     ti++;
    // }
    // for (let i = 0; i < scroll_sections.length; i++) {
    //     if (i != ti)
    //         header.children[i].setAttribute("class", ``);
    //     else
    //         header.children[i].setAttribute("class", `highlighted`);
    // }
}


function resize_video(player: Player) {

    let player_el = player.el() as HTMLElement;
    let header = player_el.parentElement as HTMLElement;

    let header_width = header?.offsetWidth || 0;
    let header_height = header?.offsetHeight || 0;

    // resize video to cover header in width or height
    let header_ratio = header_width / header_height;
    let video_ratio = video_width / video_height;
    

    if (header_ratio > video_ratio) {

        let new_video_height = header_width / video_ratio;
        player_el.style.width = `${header_width}px`;
        player_el.style.height = `${new_video_height}px`;
        player.width(header_width);
        player.height(new_video_height);
        
    } else {

        let new_video_width = header_height * video_ratio;
        player_el.style.width = `${new_video_width}px`;
        player_el.style.height = `${header_height}px`;
        player.width(new_video_width);
        player.height(header_height);
    }
}


function resize_maps(){
    let maps = document.getElementsByClassName("map");
    for (let i = 0; i < maps.length; i++) {
        let map_el = maps[i] as HTMLElement;
        resize_map(map_el);
    }
}

function resize_map(map_el){
    let parent = map_el.parentElement as HTMLElement;
    // get map width (without scale)
    let w = getComputedStyle(map_el).width;
    let parent_width = parent.offsetWidth;
    let r = parent_width / parseFloat(w);
    
    map_el.style.scale = `${ Math.ceil(r * 1000) / 1000 }`;
}


function create3Dscene(){
    scene_3d = new scene3D();
    scene_3d.init();
    scene_3d.resize(window.innerWidth, window.innerHeight);
    setTimeout(() => {
        scene_3d.resize(window.innerWidth, window.innerHeight);
    }, 500);
        
}   

export function rgb2hex(r, g, b){
    return (r << 16) + (g << 8) + b;
}



const bike_gltf = require("../assets/bike.glb");
const VIEW = {fov:30, near:0.1,far:1000}
const WIDTH_HEIGHT = {width: 2.0, height: 1.8};
const FRAME_RATE = 25;
const target = new THREE.Vector3(0, 0.4, 0);
const TILE_WIDTH = 300;
const TILE_WIDTH_RESPONSIVE_VERTICAL = 0.7;
const TILE_HEIGHT = 57;
const TILE_HEIGHT_RESPONSIVE_VERTICAL = 110;
class scene3D{


    width:number;
    height:number;
    resposive_vertical_changed = false;
    resposive_vertical:boolean = undefined;

    scene:THREE.Scene;
    renderer:THREE.WebGLRenderer;
    view:THREE.PerspectiveCamera;
    bike:THREE.Group = undefined;
    svg:SVGElement;
    bike_obj_pos:{[key: string]: THREE.Vector3} = {};
    bike_obj_start_pos:{[key: string]: THREE.Vector3} = {};
    bike_obj_times:{[key: string]: number} = {};
    
    t:number=undefined;
    last_t:number=undefined;
    t_target:number=0;

    scroll_target:number=undefined;
    last_scroll:number=undefined;

    header:HTMLElement;
    tile_margin_top:number=0;

    tiles:HTMLCollectionOf<Element>;
    go_to_tiles_btns:HTMLCollectionOf<Element>;
    tiles_desc_hights:number[] = [];
    tiles_full_hights:number[] = [];

    forced_update:boolean = false;

    total_tile_height:number = 0;
    total_open_tile_height:number = 0;

    track_video_id:string = undefined;
    track_video_player:Player = undefined;
    track_video_player_el:HTMLElement = undefined;
    track_video_container:HTMLElement = undefined;

    init(){
        this.scene = new THREE.Scene();
        // this.scene.background = new THREE.Color(rgb2hex(169, 199, 201));

        this.view = new THREE.PerspectiveCamera(VIEW.fov, window.innerWidth / window.innerHeight, VIEW.near, VIEW.far);
        this.view.position.x = 4;
        this.view.position.y = 0.5;
        this.view.position.z = 0;
        this.view.lookAt(0, 0.5, 0);

        // const ambientLight = new THREE.AmbientLight(0x999999); // soft white light
        // this.scene.add(ambientLight);

        const directionalLight = new THREE.DirectionalLight(rgb2hex(252, 249, 227), 1.0);
        directionalLight.position.set(-1, 0.5, -3);
        directionalLight.castShadow = false;
        this.scene.add(directionalLight);


        const directionalLight3 = new THREE.DirectionalLight(rgb2hex(252, 249, 227), 1.5);
        directionalLight3.position.set(3, 2, 0);
        directionalLight3.castShadow = false;
        this.scene.add(directionalLight3);

        const directionalLight2 = new THREE.DirectionalLight(rgb2hex(96, 123, 224), 4.0);
        directionalLight2.position.set(0, -1, 1);
        directionalLight2.castShadow = false;
        this.scene.add(directionalLight2);

        this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, canvas: document.getElementById('threejs') });
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.toneMapping = THREE.ReinhardToneMapping;
        this.renderer.toneMappingExposure = 1.2;
        
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
        const gltfLoader = new GLTFLoader();
        gltfLoader.setDRACOLoader(dracoLoader);

        // replace bike with a cube
        this.bike = new THREE.Group();
        this.bike.position.set(0, 0.5, 0.15);


        gltfLoader.load(bike_gltf, (gltf) => {
            let pos = this.bike.position.clone();
            let scale = this.bike.scale.clone();
            this.bike = gltf.scene;
            
            this.bike.position.set(pos.x, pos.y, pos.z);
            this.bike.scale.set(scale.x, scale.y, scale.z);
            this.compute_geometry(this.bike);
            this.scene.add(this.bike);
            this.update_scroll();
            this.anime_ids = {}; // update
            document.getElementById("loading").style.display = "none";
        });

        setInterval(()=>{
            this.renderer.render(this.scene, this.view);
            this.update();
        }, 1000/FRAME_RATE);

        

        this.header = document.getElementById("header") as HTMLElement;
        this.svg = document.getElementById("bike-svg") as any;
        this.tiles = document.getElementsByClassName("tile")
        this.go_to_tiles_btns = document.getElementsByClassName("tile-header-btn");

        this.forced_update = false;

        for (let i = 0; i < this.tiles.length; i++) {
            let polyline = document.createElementNS("http://www.w3.org/2000/svg", "polyline");
            polyline.setAttribute("fill", "none");
            polyline.setAttribute("stroke", "#cc1d1d");
            polyline.setAttribute("stroke-width", "3");
            this.svg.appendChild(polyline);
            this.tiles_desc_hights.push(0);
            this.tiles_full_hights.push(0);
        }
        
        this.resize(window.innerWidth, window.innerHeight);


        document.getElementById("scroll-to-activites").addEventListener("click", (e) => {
            this.emulate_scroll(0.728);
        });
        document.getElementById("scroll-to-activites2").addEventListener("click", (e) => {
            this.emulate_scroll(0.728);
        });
        document.getElementById("h-accueil").addEventListener("click", (e) => {
            e.preventDefault();
            history.pushState(null, "", "/home");
            this.emulate_scroll(0.728);
            if (this.resposive_vertical) document.getElementById("header-nav").style.display = "";
        });
        document.getElementById("scroll-to-ecole").addEventListener("click", (e) => {
            this.emulate_scroll(1);
        });
        document.getElementById("h-ecole").addEventListener("click", (e) => {
            e.preventDefault();
            history.pushState(null, "", "/ecole");
            this.emulate_scroll(1);
            if (this.resposive_vertical) document.getElementById("header-nav").style.display = "";
        });
        document.getElementById("scroll-to-pistes").addEventListener("click", (e) => {
            this.emulate_scroll(2);
        });
        document.getElementById("h-pistes").addEventListener("click", (e) => {
            e.preventDefault();
            history.pushState(null, "", "/pistes");
            this.emulate_scroll(2);
            if (this.resposive_vertical) document.getElementById("header-nav").style.display = "";
        });
        document.getElementById("scroll-to-adultes").addEventListener("click", (e) => {
            this.emulate_scroll(3);
        });
        document.getElementById("h-adultes").addEventListener("click", (e) => {
            e.preventDefault();
            history.pushState(null, "", "/adultes");
            this.emulate_scroll(3);
            if (this.resposive_vertical) document.getElementById("header-nav").style.display = "";
        });
        document.getElementById("h-contactes").addEventListener("click", (e) => {
            e.preventDefault();
            history.pushState(null, "", "/contact");
            this.emulate_scroll(4);
            if (this.resposive_vertical) document.getElementById("header-nav").style.display = "";
        });
        document.getElementById("contact0").addEventListener("click", (e) => {
            this.emulate_scroll(4);
        });
        document.getElementById("contact1").addEventListener("click", (e) => {
            this.emulate_scroll(4);
        });

        document.getElementById("btn-green").addEventListener("click", (e) => {
            this.toggle_track_video(e, "green");
        });
        document.getElementById("btn-blue").addEventListener("click", (e) => {
            this.toggle_track_video(e, "blue");
        });
        document.getElementById("btn-red").addEventListener("click", (e) => {
            this.toggle_track_video(e, "red");
        });
        document.getElementById("btn-black").addEventListener("click", (e) => {
            this.toggle_track_video(e, "black");
        });
        document.getElementById("btn-sharktooth").addEventListener("click", (e) => {
            this.toggle_track_video(e, "sharktooth");
        });
        document.getElementById("btn-fourcross").addEventListener("click", (e) => {
            this.toggle_track_video(e, "fourcross");
        });
        document.getElementById("btn-bernard").addEventListener("click", (e) => {
            this.toggle_track_video(e, "bernard");
        });
        document.getElementById("btn-remontee").addEventListener("click", (e) => {
            this.toggle_track_video(e, "remontee");
        });

        // read the url if (/ecole) scroll to ecole, if (/pistes) scroll to pistes, if (/adultes) scroll to adultes
        if (window.location.href.indexOf("/home") > -1){
            this.emulate_scroll(-1);
        } else if (window.location.href.indexOf("/ecole") > -1){
            this.emulate_scroll(2.6);
        } else if (window.location.href.indexOf("/pistes") > -1){
            this.emulate_scroll(2.82);
        } else if (window.location.href.indexOf("/adultes") > -1){
            this.emulate_scroll(3.2);
        } else if (window.location.href.indexOf("/contact") > -1){
            this.emulate_scroll(3.6);
        }

        // after 3 seconds reset the url
        setTimeout(() => {
            history.replaceState(null, "", "/");
        }, 3000);

        document.getElementById("menu-btn").addEventListener("click", (e) => {
            let el = document.getElementById("header-nav");
            if (el.style.display == "flex"){
                el.style.display = "";
            } else {
                el.style.display = "flex";
            }
        }); 

        this.last_scroll = window.scrollY;
    }

    
    static hashCode(str: string): number {
        var hash = 0, i, chr;
        if (str.length === 0) return hash;
        for (i = 0; i < str.length; i++) {
          chr   = str.charCodeAt(i);
          hash  = ((hash << 5) - hash) + chr;
          hash |= 0; // Convert to 32bit integer
        }
        // force between 0 and 1
        return hash / 0x7FFFFFFF;
    }

    compute_geometry(parts, origin=undefined){
        if (origin == undefined){
            origin = new THREE.Vector3(0, 0, 0);
        }
        if (parts.children.length > 0){
            for (let i = 0; i < parts.children.length; i++) {
                this.compute_geometry(parts.children[i], origin.clone().add(parts.position));
            }
        }
        else if (parts.children.length == 0){
            let part = parts;
            if (part.geometry){
                this.bike_obj_pos[part.uuid] = part.position.clone().add(origin);
                
                let random_seed = "TIpP";
                let x = scene3D.hashCode(random_seed+part.name.toUpperCase()+"X");
                let y = scene3D.hashCode(random_seed+part.name+"Y");
                let z = scene3D.hashCode(random_seed+part.name.toLowerCase()+"Z");
                this.bike_obj_start_pos[part.uuid] = new THREE.Vector3(x, y, z).normalize().multiplyScalar(5);
                this.bike_obj_times[part.uuid] = (scene3D.hashCode("C"+random_seed+part.name)+1)/2.0/1.3;
            }
        }
    }

// |====================================================================================================================
// | RESIZE
// |====================================================================================================================

    resize_3D_scene(w, h){
        
        let scale = 1
        let width = w;
        let height = h;
        if(width<height && w < 800){
            scale = w / 800;
            height = h / scale;
            width = 800;
        }
        if (height<width && height < 800){
            scale = h / 800;
            width = w / scale;
            height = 800;
        }
        // get element
        this.renderer.domElement.style.transform = `scale(${scale})`;
        

        this.view.aspect = width / height;
        const aspect = width / height;
        const fov = this.view.fov * ( Math.PI / 180 );
        const fovh = 2*Math.atan(Math.tan(fov/2) * aspect);
        let dx = 0 / 2 + Math.abs( WIDTH_HEIGHT.width / 2 / Math.tan( fovh / 2 ) );
        let dy = 0 / 2 + Math.abs( WIDTH_HEIGHT.height / 2 / Math.tan( fov / 2 ) );
        let cameraZ = Math.max(dx, dy);


        this.view.position.x = cameraZ;
        this.view.updateProjectionMatrix();
        this.renderer.setSize( width, height);


        this.svg.setAttribute("width", `${w}`);
        this.svg.setAttribute("height", `${h}`);
        this.svg.setAttribute("scale", `${scale}`);
        this.svg.setAttribute("viewBox", `0 0 ${w} ${h}`);

        
    }


    compute_tile_heights(width, height){
        // add 3 polylines
        this.total_tile_height = 0;
        for (let i = 0; i < this.tiles.length; i++) {
            let tile = this.tiles[i] as HTMLElement;

            if (this.resposive_vertical){
                tile.children[1].setAttribute("style", `display: block; width: ${css_ratio_from(MAX_WIDTH_PX * TILE_WIDTH_RESPONSIVE_VERTICAL-20)}px;`);
            }else{
                tile.children[1].setAttribute("style", `display: block; width: ${css_ratio_from(TILE_WIDTH-20)}px;`);
            }

            let title_h = dimension(tile.children[0])
            let title_d = dimension(tile.children[1])
            let tille_f = 0;
            if (tile.children.length > 2){
                tille_f = dimension(tile.children[2]);
            }

            this.tiles_desc_hights[i] = title_h + title_d + css_ratio_from(20);
            
            this.tiles_full_hights[i] = title_h + tille_f + css_ratio_from(20);
            if (i > 0){
                this.total_tile_height += this.tiles_full_hights[i];
            }
        }

        this.total_tile_height += css_ratio_from(120) * (this.tiles.length -1) ; // gab between tiles
        this.total_open_tile_height = this.total_tile_height;
        this.total_tile_height += css_ratio_from(40); // padding bottom
        this.total_tile_height += document.getElementById("bike-scroller").clientHeight;
        document.getElementById("tile-scroller").style.height = `${this.total_tile_height}px`;
        document.getElementById("scroller").style.height = `${this.total_tile_height}px`;

        let bike_height = 0;
        if (width/height < WIDTH_HEIGHT.width/WIDTH_HEIGHT.height){
            bike_height = css_ratio_from(400);
        } else {
            bike_height = height * 0.35;
        }
        if (this.resposive_vertical){
            this.tile_margin_top = 0
        } else {
            this.tile_margin_top = Math.max(height/2.5 - css_ratio_from(40) - bike_height, 0);
        }
    }


    resize(width, height){
        if (width <= 600) {
            if (this.resposive_vertical !== true) this.resposive_vertical_changed = true;
            this.resposive_vertical = true;
        } else {
            if (this.resposive_vertical !== false) this.resposive_vertical_changed = true;
            this.resposive_vertical = false;
        }
        
        if (this.resposive_vertical_changed){
            if (this.resposive_vertical){
                this.bike.position.set(0, 0.23, -0.05);
                this.bike.scale.set(1.2, 1.2, 1.2);
                this.compute_geometry(this.bike);
            } else {
                this.bike.position.set(0, 0.4, 0.15);
                this.bike.scale.set(0.9, 0.9, 0.9);
                this.compute_geometry(this.bike);
            }
            this.resposive_vertical_changed = false;
        }
        map.setResponsiveVertical(this.resposive_vertical);
        width = css_ratio_from(MAX_WIDTH_PX);
        this.width = width;
        this.height = height;

        
        
        this.resize_3D_scene(width, height);

        this.forced_update = true;
        this.compute_tile_heights(width, height);
        this.resize_video_track_player();

    }

// |====================================================================================================================
// | 
// |====================================================================================================================
    

    scene_coord_to_screen(pos:THREE.Vector3){
        let vector = pos.clone();
        vector.project(this.view);
        
        let x = (vector.x + 1) / 2 * css_ratio_from(MAX_WIDTH_PX);
        let y = (-vector.y + 1) / 2 * this.height;

        return new THREE.Vector2(x, y);
    }

    compute_t(start, duration){
        let t = 0;
        if (this.t >= start && this.t < start + duration){
            t = (this.t - start) / duration;
        } else if (this.t >= start + duration){
            t = 1;
        }
        return t;
    }

    anime_ids = {};
    animation_need_update(start, duration, id){
        
        if (this.forced_update) return true;     
        if (this.last_t < start && this.t > start + duration) return true;
        if (this.last_t > start + duration && this.t < start) return true;

        if (this.t < start || this.t > start + duration){
            if (this.anime_ids[id]) return false;
            this.anime_ids[id] = true;
        } else {
            this.anime_ids[id] = false;
        }
        return true;
    }

    render_bike(parts, t, origin=undefined){
        if (origin == undefined){
            origin = new THREE.Vector3(0, 0, 0);
        }
        
        if (parts.children.length > 0){
            
            if (t <= 0) {
                if (parts.name == "Back" || parts.name == "Front"){
                    parts.rotation.x -= 1/60;
                }
                if (parts.name == "Cranck"){
                    parts.rotation.x -= 4/60;
                }
                if (parts.name == "LeftPedal" || parts.name == "RightPedal"){
                    parts.rotation.x += 4/60;
                }
            } else {
                if (parts.name == "Back" || parts.name == "Front" || parts.name == "Cranck" || parts.name == "LeftPedal" || parts.name == "RightPedal"){
                    parts.rotation.x = 0;
                }
            }
            for (let i = 0; i < parts.children.length; i++) {
                this.render_bike(parts.children[i], t, origin.clone().add(parts.position));
            }
        }
        else if (parts.children.length == 0){
            let part = parts;
            if (part.geometry){
                
                let vx = this.bike_obj_pos[part.uuid].x;
                let vy = this.bike_obj_pos[part.uuid].y;
                let vz = this.bike_obj_pos[part.uuid].z;
                let l = Math.sqrt(vx*vx + vy*vy + vz*vz);
                vx /= l;
                vy /= l;
                vz /= l;
                let v = new THREE.Vector3(vx, vy, vz).multiplyScalar(1.0);

                // when t = this.bike_obj_times[part.uuid] -> t_before = 0
                // when t = 1.0 -> t_before = 1.0
                let t_before = Math.min(Math.max((t - this.bike_obj_times[part.uuid]) / (1.0 - this.bike_obj_times[part.uuid]), 0), 1);
                
                // ease t using easeOut Cubic
                let t_easing = 1 - Math.pow(1 - t_before, 1.3);
                
                part.position.x = this.bike_obj_pos[part.uuid].x + (v.x + this.bike_obj_start_pos[part.uuid].x) * t_easing - origin.x;
                part.position.y = this.bike_obj_pos[part.uuid].y + (v.y + this.bike_obj_start_pos[part.uuid].y) * t_easing - origin.y;
                part.position.z = this.bike_obj_pos[part.uuid].z + (v.z + this.bike_obj_start_pos[part.uuid].z) * t_easing - origin.z;
                // part.rotation.x += 1;
            }
        }
    }

    update_header(){
        if (!this.animation_need_update(-0.3, 0.3, "update_header")) return;
        
        let t = this.compute_t(-0.3, 0.3);
        let blur = 20 * (1-t);
        let transparency = t;
        this.header.style.backdropFilter = `blur(${blur}px)`;
        this.header.style.backgroundColor = `rgba(41, 41, 41, ${transparency})`;

    }

    update_bike_assembly() {
        // if (!this.animation_need_update(-0.3, 0.5, "update_bike_assembly")) return;
        this.render_bike(this.bike, 1 - this.compute_t(-0.2, 0.7));
    }

    update_bike_rotation(){
        if (!this.animation_need_update(0, 0.3, "update_bike_rotation")) return;
        this.bike.rotation.y = this.compute_t(0, 0.3) * Math.PI * 1.3;
        this.bike.updateMatrixWorld();
    }

    open_line_paths(start, duration){
        if (!this.animation_need_update(start, duration, "open_line_paths")) return;
        this.update_line_paths(start, duration);
    }

    update_line_paths(start, duration){
        
        let svg_box = this.svg.getBoundingClientRect();
        let scale = parseFloat(this.svg.getAttribute("scale"));
        // set polylines path
        let bike_coords = [
            new THREE.Vector3(0, 0.57, -0.4), // Front weel
            new THREE.Vector3(0, 0., 0.2), // bottom bracket
            new THREE.Vector3(-0, 0.15, 0.8), // Rear weel
        ]
        // transform bike coords to scene coords according to bike transform        
        for (let i = 0; i < bike_coords.length; i++) {
            bike_coords[i].applyMatrix4(this.bike.matrixWorld);
        }
        


        let line_t = this.compute_t(start, duration);
        let shift_x = (window.innerWidth - css_ratio_from(MAX_WIDTH_PX)) / 2;
        for (let i = 1; i < this.tiles.length; i++) {
            let tile = this.tiles[i] as HTMLElement;
            let box = tile.getBoundingClientRect();
            let polyline = this.svg.children[i] as SVGPolylineElement;
            let points = "";

            let start = new THREE.Vector2(box.left - shift_x, box.top + box.height / 2 - svg_box.top);
            if (this.resposive_vertical){
                if (i == this.tiles.length - 1){
                    start = new THREE.Vector2(box.left - shift_x + box.width/1.3, box.top - svg_box.top);
                } else if (i == 2){
                    start = new THREE.Vector2(box.left - shift_x + box.width/2, box.bottom - svg_box.top);
                } else{
                    start = new THREE.Vector2(box.left - shift_x + css_ratio_from(TILE_HEIGHT_RESPONSIVE_VERTICAL) / 2, box.bottom - svg_box.top);
                }
            }

            let end = this.scene_coord_to_screen(bike_coords[i-1]);
            let mid = new THREE.Vector2(end.x + (end.y - start.y), end.y - (end.y - start.y));
            if (mid.x > start.x){
                mid = new THREE.Vector2(end.x, end.y + (start.y - end.y) - (end.x - start.x));
            }
            if (mid.x < end.x){
                mid = new THREE.Vector2(end.x - (end.y - start.y), end.y - (end.y - start.y));
            }
            if (mid.y < start.y){
                mid = new THREE.Vector2(start.x, end.y - (end.x - start.x));
            }

            let lenght_a = start.distanceTo(mid);
            let lenght_b = mid.distanceTo(end);
            let lenght = lenght_a + lenght_b;
            let current_length = lenght * line_t;

            if (current_length < lenght_a){
                let A = start;
                let B = new THREE.Vector2(
                    (mid.x - start.x) * (current_length / lenght_a) + start.x,
                    (mid.y - start.y) * (current_length / lenght_a) + start.y);
                points += `${A.x},${A.y} `;
                points += `${B.x},${B.y} `;
            } else {
                let A = start;
                let B = mid;
                let C = new THREE.Vector2(
                    (end.x - mid.x) * ((current_length - lenght_a) / lenght_b) + mid.x,
                    (end.y - mid.y) * ((current_length - lenght_a) / lenght_b) + mid.y);
                points += `${A.x},${A.y} `;
                points += `${B.x},${B.y} `;
                points += `${C.x},${C.y} `;
            }
            polyline.setAttribute("points", points);
            // set width
            polyline.setAttribute("stroke-width", `${3 * scale}`);

        }
    }

    update_line_paths_opacity(start, duration){
        if (!this.animation_need_update(start, duration, "update_line_paths_opacity")) return;
        let t = this.compute_t(start, duration);
        this.svg.style.opacity = `${1-t}`;
    }
    update_opacity(el:HTMLElement, start, duration, id="update_opacity", reverse=false){
        if (!this.animation_need_update(start, duration, id)) return;
        let t = this.compute_t(start, duration);
        if (reverse) t = 1 - t;
        el.style.opacity = `${t}`;
    }

    update_tile_desc(tile_i, open_t, close_t, duration){
        if (!this.animation_need_update(open_t, close_t - open_t + duration, `update_tile_desc_${tile_i}`)) return;

        let tile = this.tiles[tile_i] as HTMLElement;
        let ul = tile.querySelector(".tile-desc").getElementsByTagName("li")
        let li_d = duration / ul.length;
        let height_small
        if (this.resposive_vertical){
            height_small = css_ratio_from(TILE_HEIGHT_RESPONSIVE_VERTICAL);
        } else {
            height_small = css_ratio_from(TILE_HEIGHT);
        }
        let height_large = this.tiles_desc_hights[tile_i];

        if (this.t < close_t){
            let t = this.compute_t(open_t, duration);
            let height = height_small + (height_large - height_small) * t;
            
            if (this.t < 1.7)
                tile.style.height = `${height}px`;

            
            
            for (let i = 0; i < ul.length; i++) {
                let li = ul[i] as HTMLElement;

                t = this.compute_t(open_t + duration + li_d*(i), li_d);
                li.style.opacity = `${t}`;
            }
        }
        else{
            let t = this.compute_t(close_t, duration);
            let height = height_large + (height_small - height_large) * t;

            if (this.t < 1.7)
                tile.style.height = `${height}px`;

            for (let i = 0; i < ul.length; i++) {
                let li = ul[i] as HTMLElement;
                t = this.compute_t(close_t +li_d * (ul.length - 1) - li_d*(i), li_d);
                li.style.opacity = `${1-t}`;
            }
        }
        this.update_line_paths(0.1, 0.2);
    }

    open_tile(tile_i, open_t, duration){
        if (!this.animation_need_update(open_t, duration, `open_tile_${tile_i}`)) return;
        

        let tile = this.tiles[tile_i] as HTMLElement;

        let height_small, width_small;
        if (this.resposive_vertical){
            height_small = css_ratio_from(TILE_HEIGHT_RESPONSIVE_VERTICAL);
            width_small = css_ratio_from(MAX_WIDTH_PX * TILE_WIDTH_RESPONSIVE_VERTICAL);
        } else {
            height_small = css_ratio_from(TILE_HEIGHT);
            width_small = css_ratio_from(TILE_WIDTH);
        }
        let height_large = this.tiles_full_hights[tile_i];
        let width_large = css_ratio_from(MAX_WIDTH_PX * 0.9285) + css_ratio_from(20); // (1400-80-20)/1400



        // opening
        if (this.t <= open_t){
            (tile.getElementsByClassName("tile-desc")[0] as HTMLElement).style.display = "block";
            (tile.getElementsByClassName("tile-content")[0] as HTMLElement).style.opacity = "0";
            tile.style.width = `${width_small}px`;
            
            if (tile_i == 1) tile.style.marginTop = this.tile_margin_top + "px";
        } else {
            (tile.getElementsByClassName("tile-desc")[0] as HTMLElement).style.display = "none";
            (tile.getElementsByClassName("tile-content")[0] as HTMLElement).style.opacity = "1";
        }

        let t = this.compute_t(open_t, duration);
        
        let height = height_small + (height_large - height_small) * t;
        let width = width_small + (width_large - width_small) * t;
        tile.style.height = `${height}px`;
        tile.style.width = `${width}px`;
        
        // margin top
        if (tile_i == 1){
            let target_margin_top = ((window.innerHeight) * 0.4 - css_ratio_from(40));
            let margin_top = (target_margin_top - this.tile_margin_top) * t + this.tile_margin_top;
            tile.style.marginTop = `${margin_top}px`;
        }
        this.update_line_paths(0.1, 0.2);
    }

    open_tile_gap(open_t, duration){
        if (!this.animation_need_update(open_t, duration, "open_tile_gap")) return;
        let el = document.getElementById("tiles-container") as HTMLElement;
        let t = this.compute_t(open_t, duration);
        let gap = css_ratio_from(20) + (css_ratio_from(120) - css_ratio_from(20)) * t;
        el.style.gap = `${gap}px`;
    }

    update(){
        if (this.scroll_target !== undefined){
            let next_scroll = this.scroll_target * 0.15 + window.scrollY * 0.85;
            
            if (Math.abs(next_scroll - window.scrollY) > 1.0){
                window.scrollTo(0, next_scroll);
            } else {
                this.scroll_target = undefined;
            }
        }
        
        this.update_bike_assembly();
        
        if (this.t === undefined){
            this.t = this.t_target;
            this.last_t = this.t;
        } else{
            let next_t = this.t * 0.85 + this.t_target * 0.15;
            if (Math.abs(next_t - this.t) > 0.001){
                this.last_t = this.t;
                this.t = next_t;
            }
            else if (!this.forced_update){
                return;
            }
        }
        this.update_header();

        this.update_bike_rotation();   

        if (this.t < 0.5) this.update_opacity(this.tiles[0] as HTMLElement, 0.1, 0.2, "tile0Opa");
        else this.update_opacity(this.tiles[0] as HTMLElement, 0.8, 0.2, "tile0OpaR", true);
        this.open_tile(1, 1.7, 0.2);
        this.open_tile(2, 1.8, 0.2);
        this.open_tile(3, 1.9, 0.2);
        this.update_tile_desc(0, 0.2, 0.8, 0.05)
        this.update_tile_desc(1, 0.5, 0.8, 0.05);
        this.update_tile_desc(2, 0.9, 1.2, 0.05);
        this.update_tile_desc(3, 1.3, 1.6, 0.05);
        this.open_tile_gap(1.7, 0.4);

        this.open_line_paths(0.1, 0.2);
        this.update_line_paths_opacity(1.6, 0.2);
        for (let i = 0; i < this.go_to_tiles_btns.length; i++) {
            this.update_opacity(this.go_to_tiles_btns[i] as HTMLElement, 1.6, 0.2, `go_to_tiles_btns_${i}`, true);
        }

        this.forced_update = false;

        

    }

    update_scroll(e:Event=null){
        if (this.scroll_target != undefined){
            let vy = window.scrollY - this.last_scroll;
            let way = this.scroll_target - window.scrollY
            console.log(this.last_scroll, window.scrollY, vy, way);
            if ((vy > 0) != (way > 0)){
                this.scroll_target = undefined;
            }
        }
        

        let rect = document.getElementById("scroller").getBoundingClientRect();
        
        let y = -rect.top;

        this.t_target = y / window.innerHeight;
        this.last_scroll = window.scrollY;
        
        return this.t_target;
    }

    compute_scroll_t(px:number){
        // let rect = document.getElementById("scroller").getBoundingClientRect();
        // let top = -rect.top;
        let t = (px - window.innerHeight) / window.innerHeight;
        return t;
    }


    compute_scroll_px(t:number){
        let px = (t + 1) * window.innerHeight;

        let margin = 0;
        if (this.resposive_vertical){
            margin = css_ratio_from(240);
        } else {
            margin = css_ratio_from(40); // TODO
        }
        let page_start = this.total_tile_height - this.total_open_tile_height + window.innerHeight - margin;

        
        if (t >= 1){
            const gap = css_ratio_from(120)
            px = this.total_tile_height - this.total_open_tile_height + window.innerHeight - gap - margin;
            for (let i = 0; i < t; i++) {
                px += this.tiles_full_hights[i] + gap;
            }
        }
        let max_scroll = document.body.scrollHeight - window.innerHeight;
        if (px > max_scroll) px = max_scroll;
        return px;
    }



    emulate_scroll(t:number){
        setTimeout(() => {
            this.scroll_target = this.compute_scroll_px(t);
        }, 100);
    }



    async toggle_track_video(e, id){
        let container = document.getElementById("tracks-info")

        let width_from = 600;
        let width_to = 400;
        if(this.resposive_vertical){
            width_from = 1295 * 0.6;
            width_to = 1295 * 0.6;
        }
        let data = map_tracks[id];
        if (this.track_video_id !== undefined){
            this.track_video_player.off("timeupdate");
            let stop = false;
            if (this.track_video_id === id || data === undefined || data.gpx === undefined) {
                stop = true;
                await map.close_track(width_to, width_from, (t) => {
                    t = (1-t);
                    this.track_video_container.style.width = `${(t)*100}%`;
                    if (t > 0.8){
                        this.track_video_container.style.opacity = `${(t - 0.8)/0.2}`;
                    }
                    this.resize_video_track_player();
                });
                map.set_map_size(undefined);
                container.scrollTop = 0;
            } 
            else {
                width_from = width_to;
                await map.close_track(width_from, width_to, undefined, false);
            }

            document.getElementById("btn-"+this.track_video_id).innerText = "search";
            this.track_video_player.dispose();
            this.track_video_container.remove();
            this.track_video_player = undefined;
            this.track_video_player_el = undefined;
            this.track_video_container = undefined;
            this.track_video_id = undefined;

            if (stop) return;
        }
        
        if (data === undefined || data.gpx === undefined) return;


        e.target.innerText = "collapse_all";
        this.track_video_id = id;
        let el_before = document.getElementById("track-"+id)
        this.track_video_container = document.createElement("div");
        this.track_video_container.setAttribute("class", "video-container");
        this.track_video_container.style.opacity = "0";
        el_before.parentNode.insertBefore(this.track_video_container, el_before.nextSibling);

        this.track_video_player_el = document.createElement("video-js");
        this.track_video_player_el.setAttribute("class", "track-vid");
        this.track_video_container.appendChild(this.track_video_player_el);

        // add play button overlay
        let play_button = document.createElement("span");
        play_button.setAttribute("class", "video-play-button material-symbols-outlined");
        play_button.innerText = "play_arrow";
        


        let options = {
            controls: false,
            autoplay: false,
            preload: "auto",
            techOrder: ["youtube"],
            muted: true,
            sources: [{
                type: "video/youtube",
                src: data.url
            }],
            "youtube": { 
                "ytControls": 1,
                "iv_load_policy": 3,
                "playsinline": 1
            }
        };
        this.track_video_player = videojs(this.track_video_player_el as HTMLElement, options);
        let ended = false;
        let first_update_after_ended = true;

        // play video when ready
        this.track_video_player.ready(() => {
            this.resize_video_track_player();
            
            this.track_video_player.on("timeupdate", () => {
                let t = this.track_video_player.currentTime();
                let gpx_t = t + map_tracks[id].timestamp;

                if (ended){
                    if (first_update_after_ended){
                        // go back to start of track and stop
                        map.view_full_track(id);
                        first_update_after_ended = false;
                    }
                }
                else{
                    map.update_position_on_track(id, gpx_t);
                }
            });

            // on pause view_full_track
            this.track_video_player.on("pause", () => {
                play_button.style.display = "block";
                map.view_full_track(id);
            });
            this.track_video_player.on("play", () => {
                play_button.style.display = "none";
                first_update_after_ended = true;
                ended = false;
            });
            this.track_video_player.on("ended", () => {
                ended = true;
            });

            this.track_video_container.appendChild(play_button);
            play_button.addEventListener("click", () => {
                this.track_video_player.play();
                play_button.style.display = "none";
            });
        });
        
        map.open_track(id, width_from, width_to, (t) => {
            this.track_video_container.style.width = `${t*100}%`;
            if (t > 0.8){
                this.track_video_container.style.opacity = `${(t - 0.8)/0.2}`;
            }
            this.resize_video_track_player();
        });
        

        // scroll to tile
        container.scrollTop = el_before.offsetTop - container.offsetTop - css_ratio_from(10);
    }

    resize_video_track_player(){
        if (this.track_video_id === undefined) return;
        let container_width = this.track_video_container.offsetWidth;
        let content_width = this.track_video_player_el.offsetWidth;
        let scale = container_width / content_width;
        this.track_video_container.style.height = `${(scale*720)}px`;
        this.track_video_player_el.style.transform = `scale(${scale})`;
    }
}





class GPX{
    path:[number, number][];
    times: number[]
    box:[number, number, number, number];

    constructor(gpx_data:string){
        this.path = [];
        this.times = [];
        this.box = [180, 90, -180, -90]; // minx, miny, maxx, maxy
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(gpx_data, "text/xml");
        let trkpts = xmlDoc.getElementsByTagName("trkpt");
        for (let i = 0; i < trkpts.length; i++) {
            let lat = parseFloat(trkpts[i].getAttribute("lat"));
            let lon = parseFloat(trkpts[i].getAttribute("lon"));
            let t = trkpts[i].getElementsByTagName("time")[0];
            
            this.path.push([lon, lat]);
            this.times.push(new Date(t.getHTML()).getTime() / 1000);

            if (lon < this.box[0]) this.box[0] = lon;
            if (lat < this.box[1]) this.box[1] = lat;
            if (lon > this.box[2]) this.box[2] = lon;
            if (lat > this.box[3]) this.box[3] = lat;
        }
    }

    get_path(){
        return this.path;
    }

    get(i){
        if (i < 0) i = this.path.length + i;
        return this.path[i];
    }

    get_position(t:number): [number, number]{
        // find i before and after t
        // interpolate between
        let bi = 0;
        while (bi < this.times.length - 1 && this.times[bi+1] < t){
            bi++;
        }
        if (bi >= this.times.length - 1){
            return this.get(-1);
        }
        let ai = bi + 1;
        let dt = this.times[ai] - this.times[bi];
        let ft = (t - this.times[bi]) / dt;
        let lon = this.path[bi][0] + (this.path[ai][0] - this.path[bi][0]) * ft;
        let lat = this.path[bi][1] + (this.path[ai][1] - this.path[bi][1]) * ft;
        return [lon, lat];
    }

    static bearing_between(lon1, lat1, lon2, lat2): number{
        let y = Math.sin(toRadians(lon2 - lon1)) * Math.cos(toRadians(lat2));
        let x = Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) - Math.sin(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.cos(toRadians(lon2 - lon1));
        let bearing = toDegrees(Math.atan2(y, x));
        return bearing;
    }

    static bearing_interpolate(bearing1, bearing2, ft): number{
        let diff = bearing2 - bearing1;
        if (diff > 180) diff -= 360;
        if (diff < -180) diff += 360;
        let bearing = bearing1 + diff * ft;
        return (bearing + 360) % 360;
    }

    get_bearing(t:number): number{
        // find i before and after t
        // interpolate between
        let bi = 0;
        while (bi < this.times.length - 1 && this.times[bi+1] < t){
            bi++;
        }
        if (bi >= this.times.length - 1){
            bi = this.times.length - 2;
        }
        let ai = bi + 1;
        let lon1 = this.path[bi][0];
        let lat1 = this.path[bi][1];
        let lon2 = this.path[ai][0];
        let lat2 = this.path[ai][1];

        let bearing1 = GPX.bearing_between(lon1, lat1, lon2, lat2);

        if (ai < this.times.length - 1){
            let lat3 = this.path[ai + 1][1];
            let lon3 = this.path[ai + 1][0];
            let bearing2 = GPX.bearing_between(lon2, lat2, lon3, lat3);
            let dt = this.times[ai] - this.times[bi];
            let ft = (t - this.times[bi]) / dt;

            // interpolate bearing
            return GPX.bearing_interpolate(bearing1, bearing2, ft);
        }

        
        return bearing1
    }

    get_clicked_point(lat, lon, zoom){
        const R = 6*60
        const R_Z = R / Math.pow(2, zoom)
        let closest_i = -1;
        let closest_d = Infinity;

        

        for (let i = 0; i < this.path.length; i++) {
            let d = distance(lat, lon, this.path[i][1], this.path[i][0]);
            if (d < closest_d){
                closest_d = d;
                closest_i = i;
            }
        }
        if (closest_d < R_Z){
            return closest_i;
        }
        return -1;
    }

    get_nearest_line(lat, lon){
        let closest_i = -1;
        let closest_d = Infinity;

        for (let i = 0; i < this.path.length - 1; i++) {
            let d = distance(lat, lon, this.path[i][1], this.path[i][0]);
            if (d < closest_d){
                closest_d = d;
                closest_i = i;
            }
        }
        let sibling_i = undefined
        if (closest_i == this.path.length - 1) {
            sibling_i = closest_i -1;
            let sibling_d = distance(lat, lon, this.path[sibling_i][1], this.path[sibling_i][0]);
            let d = distance(this.path[closest_i][1], this.path[closest_i][0], this.path[sibling_i][1], this.path[sibling_i][0]);
            if (sibling_d > d) return this.path.length
            return this.path.length -1;
        }
        else if (closest_i == 0) {
            sibling_i = closest_i +1;
            let sibling_d = distance(lat, lon, this.path[sibling_i][1], this.path[sibling_i][0]);
            let d = distance(this.path[closest_i][1], this.path[closest_i][0], this.path[sibling_i][1], this.path[sibling_i][0]);
            if (sibling_d > d) return 0
            return 1;
        }
        let d_prev = distance(lat, lon, this.path[closest_i -1][1], this.path[closest_i -1][0]);
        let d_next = distance(lat, lon, this.path[closest_i +1][1], this.path[closest_i +1][0]);
        if (d_prev < d_next) return closest_i;
        return closest_i + 1;
    }

    move_pts(i, lat, lon){
        this.path[i] = [lon, lat];
    }

    delete_pts(i){
        this.path.splice(i, 1);
        this.times.splice(i, 1);
    }

    insert_pts(i, lat, lon){
        // interpolate time
        let t = 0;
        if (i == 0){
            t = this.times[0] - 1;
        } else if (i >= this.times.length){
            t = this.times[this.times.length -1] + 1;
        } else {
            let t0 = this.times[i -1];
            let t1 = this.times[i];
            let d0 = distance(lat, lon, this.path[i -1][1], this.path[i -1][0]);
            let d1 = distance(lat, lon, this.path[i][1], this.path[i][0]);
            let ft = d0 / (d0 + d1);
            t = t0 + (t1 - t0) * ft;
        }
        this.path.splice(i, 0, [lon, lat]);
        this.times.splice(i, 0, t);
    }

    download(name){
        let gpx = `<?xml version="1.0" encoding="UTF-8" standalone="no" ?>
<gpx version="1.1" creator="Map Manager" xmlns="http://www.topografix.com/GPX/1/1" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd">
<trk>
<trkseg>
`;
        for (let i = 0; i < this.path.length; i++) {
            let date = new Date(this.times[i] * 1000);
            let iso_date = date.toISOString();
            gpx += `<trkpt lat="${this.path[i][1]}" lon="${this.path[i][0]}">
<time>${iso_date}</time>
</trkpt>
`;
        }
        gpx += `</trkseg>
</trk>
</gpx>`;
        // download gpx file
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(gpx));
        element.setAttribute('download', `${name}.gpx`);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);

    }
}

class MapManager{

    map_element: HTMLElement;
    map: Map;
    tracks: {[key:string]: GPX} = {};
    default_center_zoom: [number, number, number];

    opened_track:string = undefined;
    t_on_track:number = undefined;
    resposive_vertical = false;

    edit_gpx = false;
    edit_pts_i = -1
    init(id, center:[number, number], zoom:number, disable_interactions=false){
        
        this.default_center_zoom = [center[0], center[1], zoom];
        this.map_element = document.getElementById(id);
        this.map = new Map({
            container: id,
            style: mapjson,
            center: center,
            zoom: zoom,
            
        });
    
        // add event listeners for click pressed, released and move

        this.map.on('mousedown', (e) => {
            this.mouse_down(e);
        });
        this.map.on('mouseup', (e) => {
            this.mouse_up(e);
        });
        this.map.on('mousemove', (e) => {
            this.mouse_move(e);
        });

        if (disable_interactions && !this.edit_gpx){
            this.map.scrollZoom.disable();
            this.map.boxZoom.disable();
            this.map.dragRotate.disable();
            this.map.dragPan.disable();
            this.map.keyboard.disable();
            this.map.doubleClickZoom.disable();
            this.map.touchZoomRotate.disable();
        }

        // this.map.on('moveend', () => {
        //     console.log(this.map.getCenter(), this.map.getZoom(), this.map.getBearing());
            
        // });


        // create new layer
        this.map.on('load', async () => {
            if (id == "map"){
                for (let [key, value] of Object.entries(map_tracks)) {
                    if (value.gpx){
                        let gpx_content = await(await fetch(value.gpx)).text();
                        let gpx = this.add_layer(`${key}_route`, value.color, gpx_content);
                        this.add_dot_layer(`${key}_dot`, value.color);
                        this.tracks[key] = gpx;
                    }
                }
            } else {
                let examples_GPX = await(await fetch(example_GPX)).text();
                this.add_layer("example_route", "rgb(52, 152, 219)", examples_GPX);
            }

        });
    }

    add_layer(name, color, gpx_content){
        let gpx = new GPX(gpx_content);
        this.map.addLayer({
            'id': name,
            'type': 'line',
            'source': {
                'type': 'geojson',
                'data': {
                    'type': 'Feature',
                    'properties': {},
                    'geometry': {
                        'type': 'LineString',
                        'coordinates': gpx.get_path()
                    }
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round'
            },
            'paint': {
                'line-color': color,
                'line-width': 4
            }
        });
        return gpx;
    }

    update_layer(name, gpx){
        let source = this.map.getSource(name) as GeoJSONSource;
        source.setData({
            'type': 'Feature',
            'properties': {},
            'geometry': {
                'type': 'LineString',
                'coordinates': gpx.get_path()
            }
        });
    }

    add_dot_layer(name, color){
        // add a circle layer that stay the same size when zooming
        // middle of the circle is white
        // outer of the circle is color

        this.map.addLayer({
            'id': name,
            'type': 'circle',
            'source': {
                'type': 'geojson',
                'data': {
                    'type': 'FeatureCollection',
                    'features': []
                }
            },
            'paint': {
                'circle-radius': 6,
                'circle-color': color,
                'circle-stroke-color': '#ffffff',
                'circle-stroke-width': 2
            }
        });
    }

    add_edit_gpx_layer(name, color, gpx){
        // layer of dots with the path color
        
        this.map.addLayer({
            'id': name,
            'type': 'circle',
            'source': {
                'type': 'geojson',
                'data': {
                    'type': 'Feature',
                    'properties': {},
                    'geometry': {
                        'type': 'MultiPoint',
                        'coordinates': gpx.get_path()
                    }
                }
            },
            'paint': {
                'circle-radius': 6,
                'circle-color': color,
                'circle-stroke-color': '#ffffff',
                'circle-stroke-width': 1
            }
        });
        return gpx;
    }

    update_edit_gpx_layer(name, gpx){
        let source = this.map.getSource(name) as GeoJSONSource;
        source.setData({
            'type': 'Feature',
            'properties': {},
            'geometry': {
                'type': 'MultiPoint',
                'coordinates': gpx.get_path()
            }
        });
    }

    set_dot_position(name, position:[number, number]){
        let source = this.map.getSource(name) as GeoJSONSource;
        source.setData({
            'type': 'FeatureCollection',
            'features': [{
                'type': 'Feature',
                'properties': {},
                'geometry': {
                    'type': 'Point',
                    'coordinates': position
                }
            }]
        });
    }

    remove_dot(name){
        let source = this.map.getSource(name) as GeoJSONSource;
        source.setData({
            'type': 'FeatureCollection',
            'features': []
        });
    }


    easeTo(start_center:[number, number], start_zoom:number, start_bearing:number=0, center:[number, number], zoom:number, bearing:number=0, t:number){
        this.map.jumpTo({
            center: {
                lng: start_center[0] + (center[0] - start_center[0]) * t,
                lat: start_center[1] + (center[1] - start_center[1]) * t,
            },
            zoom: start_zoom + (zoom - start_zoom) * t,
            bearing: GPX.bearing_interpolate(start_bearing, bearing, t),
        });
    }


    open_animate(duration, from_px, to_px, center:[number, number], zoom:number, bearing:number=0, on_frame:(t:number)=>void=undefined): Promise<void>{
        let start_center:[number, number] = [this.map.getCenter().lng, this.map.getCenter().lat];
        let start_zoom = this.map.getZoom();
        let start_bearing = this.map.getBearing();
        
        let promise = new Promise<void>((resolve, reject) => {
            let interval = undefined;
            let t = 0;
            interval = setInterval(() => {
                t += 1000 / 30 / duration;
                if (t >= 1){
                    t = 1;
                    this.easeTo(start_center, start_zoom, start_bearing, center, zoom, bearing, t);
                    if (from_px != to_px)
                        this.set_map_size(from_px + (to_px - from_px) * t);

                    clearInterval(interval);
                    resolve();
                }else{
                    this.easeTo(start_center, start_zoom, start_bearing, center, zoom, bearing, t);
                    if (from_px != to_px)
                        this.set_map_size(from_px + (to_px - from_px) * t);
                }

                if (on_frame) on_frame(t);

            }, 1000/30);
        });
        return promise;
    }

    

    open_track(id, width_from, width_to, on_frame:(t:number)=>void=undefined){
        // fit bound with padding
        this.opened_track = id;
        let v = map_tracks[id].view;
        if (this.resposive_vertical) v = map_tracks[id].view_responsive_vertical;

        this.open_animate(500, width_from, width_to, v.center, v.zoom, v.bearing, on_frame);

        // set line and dot layer on top
        this.map.moveLayer(`${id}_route`);
        this.map.moveLayer(`${id}_dot`);
        // increase route line width
        this.map.setPaintProperty(`${id}_route`, 'line-width', 5);

        if (this.edit_gpx){
            this.add_edit_gpx_layer(`${id}_edit`, map_tracks[id].color, this.tracks[id]);
        }

    }


    close_track(width_from=400, width_to=400, on_frame:(t:number)=>void=undefined, recenter:boolean=true): Promise<void>{
        let promise: Promise<void>;
        // if (width_from != width_to){
        if (recenter){
            promise = this.open_animate(500, width_from, width_to, [this.default_center_zoom[0], this.default_center_zoom[1]], this.default_center_zoom[2], 0, on_frame);
        } else {
            promise = new Promise<void>((resolve, reject) => { resolve(); });
        }

        // remove edit layer if exists
        if (this.edit_gpx){
            let layers = this.map.getStyle().layers;
            for (let i = 0; i < layers.length; i++) {
                if (layers[i].id.endsWith("_edit")){
                    this.map.removeLayer(layers[i].id);
                    this.map.removeSource(layers[i].id);
                }
            }
        }

        // remove dot
        this.remove_dot(`${this.opened_track}_dot`);
        // reset line width
        this.map.setPaintProperty(`${this.opened_track}_route`, 'line-width', 4);


        this.opened_track = undefined;
        this.t_on_track = undefined;
        return promise;
    }


    
    update_position_on_track(id, t:number=undefined){
        if (t != undefined) this.t_on_track = t;

        let gpx = this.tracks[id];
        if (gpx === undefined) return;
        let position = gpx.get_position(this.t_on_track );
        let bearing = gpx.get_bearing(this.t_on_track );
        this.set_dot_position(`${id}_dot`, position);
        if (!this.edit_gpx){
            this.map.easeTo({
                center: position,
                zoom: map_tracks[id].view.zoom_follow,
                bearing: bearing,
                duration: 1000,
                easing: function (t) { return t; }
            });
        }
    }

    view_full_track(id){
        if (!this.edit_gpx){
            let v = map_tracks[id].view;
            if (this.resposive_vertical) v = map_tracks[id].view_responsive_vertical;
            
            this.map.easeTo({
                ...v,
                duration: 1000,
                easing: function (t) { return t; }
            });
        }
    }
    mouse_down(e){
        if (!this.edit_gpx) return;

        
        let opened_gpx = this.tracks[this.opened_track];
        let i = opened_gpx.get_clicked_point(e.lngLat.lat, e.lngLat.lng, this.map.getZoom());
        if (i != -1){
            if (e.originalEvent.button == 0){
                this.edit_pts_i = i;
                e.preventDefault();
            }
            else if (e.originalEvent.button == 2){
                opened_gpx.delete_pts(i);
                this.update_layer(`${this.opened_track}_route`, opened_gpx);
                this.update_edit_gpx_layer(`${this.opened_track}_edit`, opened_gpx);
                this.update_position_on_track(this.opened_track);
                e.preventDefault();
            }
        }
        // if right click
        else if (e.originalEvent.button == 2){
            let insert_i = opened_gpx.get_nearest_line(e.lngLat.lat, e.lngLat.lng);
            opened_gpx.insert_pts(insert_i, e.lngLat.lat, e.lngLat.lng);
            this.update_layer(`${this.opened_track}_route`, opened_gpx);
            this.update_edit_gpx_layer(`${this.opened_track}_edit`, opened_gpx);
            this.update_position_on_track(this.opened_track);
        }
        else if (e.originalEvent.button == 1){
            opened_gpx.download(this.opened_track);
        }
    }

    mouse_move(e){        
        if (this.edit_pts_i != -1){
            // prevent map move
            e.preventDefault();
            
            this.tracks[this.opened_track].move_pts(this.edit_pts_i, e.lngLat.lat, e.lngLat.lng)
            this.update_layer(`${this.opened_track}_route`, this.tracks[this.opened_track]);
            this.update_edit_gpx_layer(`${this.opened_track}_edit`, this.tracks[this.opened_track]);
            this.update_position_on_track(this.opened_track);
        }
    }

    mouse_up(e){
        this.edit_pts_i = -1
    }

    set_map_size(w){
        let parent = this.map_element.parentElement as HTMLElement;
        if (w === undefined){
            this.map_element.style.width = ``;
            this.map_element.style.scale = ``;
            parent.style.width = ``;
            resize_map(this.map_element);
            return;
        }

        // set parent width 
        parent.style.width = `${css_full_ratio_from(w)}`;
        let parent_width = parent.offsetWidth;
        let r = parent_width / parseFloat(w);
        this.map_element.style.width = `${ w }px`;
        this.map_element.style.scale = `${ Math.ceil(r * 1000) / 1000 }`;
        
        
    }

    setResponsiveVertical(responsive:boolean){
        this.resposive_vertical = responsive;
    }

}